import * as yup from "yup";

export const vehicleBasicInfoSchema = yup.object({
  segmentName: yup
    .string()
    .trim()
    .required("Segment name is required")
    .max(20, "Maximum 20 characters allowed")
    .matches(/^[a-zA-Z\s]+$/, "Segment name can only contain alphabets (no numbers or special characters)"),
  vehicleTypes: yup
    .string()
    .trim()
    .required("Vehicle type is required")
    .max(20, "Maximum 20 characters allowed"),
  passengerCapacity: yup
    .number()
    .typeError("Passenger capacity must be between 1 to 15")
    .required("Passenger capacity must be between 1 to 15")
    .min(1, "Passenger capacity must be between 1 to 15")
    .max(15, "Passenger capacity must be between 1 to 15"),
  luggageCapacity: yup
    .number()
    .typeError("Luggage capacity must be between 0 to 20")
    .required("Luggage capacity must be between 0 to 20")
    .min(0, "Luggage capacity must be between 0 to 20")
    .max(20, "Luggage capacity must be between 0 to 20"),
  status: yup.string().required("Status is required"),
});

export const validateBasicVehicleFields = (data = {}) => {
  try {
    vehicleBasicInfoSchema.validateSync(
      {
        segmentName: data.segmentName,
        vehicleTypes: data.vehicleTypes,
        passengerCapacity: data.passengerCapacity,
        luggageCapacity: data.luggageCapacity,
        status: data.status,
      },
      { abortEarly: false }
    );
    return {};
  } catch (error) {
    const formErrors = {};
    if (Array.isArray(error.inner)) {
      error.inner.forEach((item) => {
        if (item.path && !formErrors[item.path]) {
          formErrors[item.path] = item.message;
        }
      });
    }
    return formErrors;
  }
};
